import { settings } from "@alme/ui-web/settings/settings-util";
import 'regenerator-runtime/runtime';
//@ts-ignore
import * as postMessageUtilities from "@alme/ui-web/modules/lib-postmessage/lib/lib-postmessage";
import { Store } from "redux";
import * as Reducers from "./reducers/index";
import { AlightCustomSettingsType } from "../../settings/alight-custom-settings";
import { AlightStateType } from "../../types/alight-state";
import { traceLog } from "../../src/logging";
import { sendRequest } from "@alme/ui-web/modules/lib-alme-request/src/lib-alme-request";
import { Input } from "@alme/ui-web/types/input";
import { waitForIvaFunction } from "../lib-alight-library/lib-alight-library";

/**
 * received from the ClientCommunicator. It also removes the message after it is processed.
 */
export default class SearchInputProcessor {
  _settings: typeof settings;
  _store: Store<AlightStateType> | undefined;
  _initializationPromises: any;

  constructor(passedSettings: AlightCustomSettingsType) {
    this._settings = passedSettings || settings;
  }

  initialize(store: Store<AlightStateType>, initPromise: any) {
    this._store = store;
    this._initializationPromises = initPromise;

    postMessageUtilities.setupStateWatchForReceivedMessages(
      this._settings,
      this._store,
      this.processSearchInput.bind(this)
    );
  }

  static getDefaultSettings() {
    return settings;
  }

  getReducer() {
    return Reducers.reducer;
  }

  async processSearchInput(newVal: any) {
    const msg = postMessageUtilities.getAndValidateMessage(
      newVal,
      "searchinput"
    );
 
    if (msg == null) {
      return;
    }
 
    traceLog(`Search Input Post Message recieved. ${msg}`);
    if (msg.message.Data.input == null || "") {
      traceLog("Value for input was empty or not found.");
      postMessageUtilities.setIsProcessed(
        this._settings,
        this._store,
        msg.message
      );
      return;
    }
   
    return waitForIvaFunction().then(async () => {
      await this._initializationPromises.onLaunch;
      traceLog(`Sending input ${msg.message.Data.input} to alme api.`);
      // send input to alme
      const message = {
        messageType: this._settings.messageConstants.converseRequest,
        text: msg.message.Data.input,
        origin: this._settings.originConstants.external,
      };
 
      sendRequest(message as Input);
      postMessageUtilities.setIsProcessed(
        this._settings,
        this._store,
        msg.message
      );
    });
  }
  
}



// WEBPACK FOOTER //
// ./modules/process-search-input-post/searchInputProcessor.ts